import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { GooglePlaceModule } from '../shared/directives/index';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { SharedService } from './shared/shared.service';
import { CardComponent } from './components/card.component';
import { CardMainComponent } from './components/card-main.component';
import { CardActivateComponent } from './components/card-activate.component';
import { ThankYouPageComponent } from './components/thankYouPage.component';
import { SystemMessagesComponent } from '../shared/components/system-message/system-messages.component';
import { DevextremePhoneInputModule } from './../../custom_modules/devextreme-phone-input/devextreme-phone-input.module';
import { AddressAutocompleteComponent } from '../../custom_modules/autocomplete/address-autocomplete.component';
import { CountryHttpService } from '../core/http/internal/country.http.service';
import { HttpCoreModule } from '../core/http.core.module';
import { SharedToastrModule } from '../shared/refactored/toastr.module';

const appRoutes: Routes = [
    { path: 'card', component: CardComponent },
    { path: 'card/activate', component: CardActivateComponent },
    { path: '', redirectTo: 'card', pathMatch: 'full' },
    { path: '**', redirectTo: 'card' }
];

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        SharedToastrModule,
        HttpCoreModule.forRoot(),
        FormsModule,
        GooglePlaceModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxButtonModule,
        DxValidatorModule,
        DxLoadIndicatorModule,
        DevextremePhoneInputModule,
        RouterModule.forRoot(appRoutes),
        DxValidationGroupModule,
        DxCheckBoxModule,
    ],

    declarations: [
        CardMainComponent,
        CardActivateComponent,
        CardComponent,
        SystemMessagesComponent,
        ThankYouPageComponent,
        AddressAutocompleteComponent
    ],

    providers: [Title, SharedService, CountryHttpService],

    bootstrap: [CardMainComponent],

    entryComponents: []
})

export class CardModule { }



// WEBPACK FOOTER //
// ./src/app/card/card.module.ts